import { Component, OnInit, ElementRef, OnDestroy, inject } from '@angular/core';
import { configModel } from 'src/models/config.model';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { AuthGaurdService } from 'src/services/auth-gaurd.service';
import { Subscription, fromEvent, merge, timer } from 'rxjs';
import { filter,switchMap } from 'rxjs/operators';
import { AppConfig } from './app.config';
import { UserAccessService } from '../services/useraccess.service';
import { AppService } from './app.service';
import { AuthStore } from './store/authorization/auth.store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly authStore = inject(AuthStore);
  
  config: configModel;
  title = 'ngSFC';
  adminHeader: string;
  adminHeaderFlag: boolean = false;
  aboutus: string;
  hcontact: string;
  sessionInactiveTime: number;
  currentUserId: string;
  roleId: number;

  constructor(
    private elementRef: ElementRef, 
    private authGaurd: AuthGaurdService, 
    private _router1: Router,
    private userStateService: AppService,
    private userAccessService: UserAccessService
  ) {
    this.authGaurd.isAdmin = this.elementRef.nativeElement.getAttribute("isAdmin");
    this.sessionInactiveTime = this.elementRef.nativeElement.getAttribute("allowedSessionInactiveTime") * 1000;
    AppConfig.appsettings = {
      apiRoot: (this.elementRef.nativeElement.getAttribute("webRoot") ?? "") + "api",
      navigatorRoot: this.elementRef.nativeElement.getAttribute("webRoot") ?? "",
      gtmcode: this.elementRef.nativeElement.getAttribute("gtmcode") ?? "",
      token: this.elementRef.nativeElement.getAttribute("token") ?? "",
      apiUrl: this.elementRef.nativeElement.getAttribute("apiUrl") ?? "",
      tenantId: this.elementRef.nativeElement.getAttribute("tenantId") ?? "",
      redirectUrl: this.elementRef.nativeElement.getAttribute("redirectUrl") ?? "",
    };
    this.currentUserId = this.elementRef.nativeElement.getAttribute("userId");
  }
  router: string;

  private userActivityEvents = ['mousemove', 'click', 'touchstart', 'keypress'];
  private userActivitySubscription: Subscription;
  private routeSub?: Subscription;
  ngOnInit() {
    const apply = () => {
      const url = (window.location.pathname + window.location.hash).toLowerCase();
      const hide = url.includes('privacypolicyform');
      document.body.classList.toggle('hide-footer-links', hide);
    };

    apply(); // first load
    this.routeSub = this._router1.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => apply());
    if(this.currentUserId !== '') {
      this.userStateService.setCurrentUserId(this.currentUserId);
    }

    if (this.authGaurd.isAdmin == "true") {
      let currentHash = window.location.hash;
      if (!currentHash.includes('/adminhome/')) {
        this._router1.navigate(['adminhome']);
      }

      this.userAccessService.getUserAccessByUserId(this.currentUserId).subscribe(
        (userModels) => {
          this.authStore.setUserAccessData(userModels);
        }
      );
    }

    this.router = location.href;
    this.adminHeader = document.location.href;
    if (this.adminHeader.includes('adminhome')) {
      this.startUserActivityTimer();
    }

    if (this.adminHeader.includes('/#/admin')) {
      this.adminHeaderFlag = true;
    }
    else {
      this.adminHeaderFlag = false;
    }
     
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
    this.userActivitySubscription.unsubscribe();
    this.userStateService.clearCurrentUserId();
  }

  startUserActivityTimer() {
    this.userActivitySubscription = merge(
      ...this.userActivityEvents.map(event => fromEvent(document, event))
    )
      .pipe(
        switchMap(() => timer(this.sessionInactiveTime))
      )
      .subscribe(() => {
        alert('Session expired due to inactivity.');
        window.location.reload();
      });
  }
}
